export default __webpack_public_path__ + "static/img/other_services_dashboard_image.0d50ffc.svg";